import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatButtonToggleGroup } from "@angular/material/button-toggle";
import { CorporateService } from "../corporate.service";
import { MatTableDataSource } from "@angular/material/table";
import { ledgerList } from "./ledgerList";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { formatDate } from "@angular/common";
import * as FileSaver from "file-saver";

@Component({
  selector: "app-corporate-ledger",
  templateUrl: "./corporate-ledger.component.html",
  styleUrls: ["./corporate-ledger.component.css"],
})
export class CorporateLedgerComponent implements OnInit {
  ledgerForm: FormGroup;
  displayedColumns: string[] = [
    "date",
    "WONo",
    "TripNo",
    "LRNo",
    "From",
    "To",
    "TruckNo",
    "DDCNo",
    "LoadedQty",
    "priceTon",
    "UnloadedQty",
    "TotalNo",
    "SalesOrderNo",
  ];
  ledgerList: MatTableDataSource<ledgerList>;

  minDate = new Date();
  searchData: boolean = false;
  searchOpen: boolean = true;
  toggleSearch: boolean = false;
  token: any;
  downloadArray: any;
  ledgerArray: any = [];
  listArray: any = [];
  data: any = [];
  xlData: any = [];
  example: any = [];
  fromCityDetails: any;
  toCityDetails: any;
  tripDetails: any;
  lrDetails: any;
  vehicleDetails: any;
  vehicalCatDetails: any;
  salesorderDetails: any;
  workOrderDetails: any;
  tripStatusDetails: any;
  selectedTripData: any = -1;
  fromLocation: any = -1;
  toLocation: any = -1;
  fromDate: any = -1;
  toDate: any = -1;
  lrNo: any = -1;
  vchlNo: any = -1;
  salesOrder: any = -1;
  workOrder: any = -1;
  tripStatus: any = -1;
  download: any = -1;
  perPage: any = 10;
  page: any = 1;
  from_location: any;
  trip_data: any;
  lr_data: any;
  to_loaction: any;
  vehicle_data: any;
  vehicle_catg_data: any;
  sales_data: any;
  WO_data: any;
  tripStatus_data: any;
  ledger_date: any;
  studentData = {
    names: [],
    ages: [],
    address: [],
    subjects: [],
    emails: [],
  };
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  downloadLedger = 1;
  ledgerLoading: boolean = false;

  constructor(
    private router: Router,
    private service: CorporateService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    this.ledgerForm = this.formBuilder.group({
      from_loc: [""],
      to_loc: [""],
      from_date: [""],
      to_date: [""],
      trip_id: [""],
      lr_no: [""],
      vehicle_no: [""],
      vehicle_catg: [""],
      sales_order: [""],
      work_order: [""],
      trip_status: [""],
    });
    this.listLedger(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.selectedTripData,
      this.lrNo,
      this.vchlNo,
      this.salesOrder,
      this.workOrder,
      this.tripStatus,
      this.download,
      this.perPage,
      this.page
    );
    this.getDropDownList();
  }

  searchBtn() {
    this.searchData = !this.searchData;
    this.toggleSearch = !this.toggleSearch;
    this.searchOpen = !this.searchOpen;
    this.ledgerForm.value.trip_id = "";
    this.listLedger(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.selectedTripData,
      this.lrNo,
      this.vchlNo,
      this.salesOrder,
      this.workOrder,
      this.tripStatus,
      this.download,
      this.perPage,
      this.page
    );
  }

  applyFilter() {
    // this.download = this.downloadLedger;
    if (this.ledgerForm.value.from_date) {
      this.listLedger(
        formatDate(
          new Date(this.ledgerForm.value.from_date),
          "yyyy-MM-dd",
          "en-US"
        ) || this.fromDate,
        formatDate(
          new Date(this.ledgerForm.value.to_date),
          "yyyy-MM-dd",
          "en-US"
        ) || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.to_date) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.from_loc) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.to_loc) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.trip_id) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.lr_no) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.vehicle_no) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.vehicle_catg) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.sales_order) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.work_order) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ledgerForm.value.trip_status) {
      this.listLedger(
        this.ledgerForm.value.from_date || this.fromDate,
        this.ledgerForm.value.to_date || this.toDate,
        this.ledgerForm.value.from_loc || this.fromLocation,
        this.ledgerForm.value.to_loc || this.toLocation,
        this.ledgerForm.value.trip_id || this.selectedTripData,
        this.ledgerForm.value.lr_no || this.lrNo,
        this.ledgerForm.value.vehicle_no || this.vchlNo,
        this.ledgerForm.value.sales_order || this.salesOrder,
        this.ledgerForm.value.work_order || this.workOrder,
        this.ledgerForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  GoToDashboard() {
    this.router.navigateByUrl("/corporate/dashboard");
  }

  GoToBookATrips() {
    this.router.navigateByUrl("/corporate");
  }

  GoToTrips() {
    this.router.navigateByUrl("/corporate/trips");
  }

  GoTOWorkOrders() {
    this.router.navigateByUrl("/corporate/work-order-list");
  }

  GoToLedger() {
    location.reload();
    this.router.navigateByUrl("/corporate/ledger");
  }

  getDropDownList() {
    this.service.listDropDown(this.token).subscribe(
      (response: any) => {
        this.fromCityDetails = response.body.data.fromCityDetail;
        this.toCityDetails = response.body.data.toCityDetail;
        this.tripDetails = response.body.data.tripNumbers;
        this.lrDetails = response.body.data.lr_Numbers;
        this.vehicleDetails = response.body.data.truck_data;
        this.vehicalCatDetails = response.body.data.truck_catgory_name;
        this.salesorderDetails = response.body.data.sls_order_Nos;
        this.workOrderDetails = response.body.data.workOrder_data;
        this.tripStatusDetails = response.body.data.trip_status;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  Search() {
    this.download = this.downloadLedger;
    let tripId = this.ledgerForm.controls["trip_id"].value;
    this.listLedger(
      this.ledgerForm.value.from_date || this.fromDate,
      this.ledgerForm.value.to_date || this.toDate,
      this.ledgerForm.value.from_loc || this.fromLocation,
      this.ledgerForm.value.to_loc || this.toLocation,
      tripId || this.selectedTripData,
      this.ledgerForm.value.lr_no || this.lrNo,
      this.ledgerForm.value.vehicle_no || this.vchlNo,
      this.ledgerForm.value.sales_order || this.salesOrder,
      this.ledgerForm.value.work_order || this.workOrder,
      this.ledgerForm.value.trip_status || this.tripStatus,
      this.download,
      this.perPage,
      this.page
    );
  }

  downloadXl(downloadArray: string) {
    if (downloadArray === "") {
      this.download = this.downloadLedger;
      let from = "Download";
      this.listLedger(
        this.fromDate,
        this.toDate,
        this.fromLocation,
        this.toLocation,
        this.selectedTripData,
        this.lrNo,
        this.vchlNo,
        this.salesOrder,
        this.workOrder,
        this.tripStatus,
        this.download,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(downloadArray, "_blank");
    }
  }

  listLedger(
    fromDate: any,
    toDate: any,
    fromLocation: any,
    toLocation: any,
    selectedTripData: any,
    lrNo: any,
    vchlNo: any,
    salesOrder: any,
    workOrder: any,
    tripStatus: any,
    dowwnload: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.ledgerLoading = true;
    this.ledgerList = new MatTableDataSource();
    this.service
      .ledgerList(
        this.token,
        fromDate,
        toDate,
        fromLocation,
        toLocation,
        selectedTripData,
        lrNo,
        vchlNo,
        salesOrder,
        workOrder,
        tripStatus,
        this.download,
        perPage,
        page
      )
      .subscribe(
        (response: any) => {
          this.ledgerArray = [];
          this.data = [];
          this.xlData = [];
          this.ledgerLoading = false;
          this.downloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.downloadArray, "_blank");
          }
          this.ledgerArray = response.body.data;
          this.document_array.push(response.body.meta);

          this.ledgerArray.forEach((ele: any) => {
            if (ele.paymentLedgerInfo && ele.paymentLedgerInfo.length > 0) {
              for (var k = 0; k < ele.paymentLedgerInfo.length; k++) {
                this.ledger_date = ele.paymentLedgerInfo[k];
                ele.paymentLedgerInfo[k].workorder_id = ele.workorder_id;

                let ledgerData = [];
                ledgerData.push(
                  formatDate(
                    new Date(ele.paymentLedgerInfo[k].pickup_date),
                    "yyyy-MM-dd",
                    "en"
                  )
                );

                ledgerData.push(ele.paymentLedgerInfo[k].workorder_id);
                ledgerData.push(ele.paymentLedgerInfo[k].trip_id);
                ledgerData.push(
                  ele.paymentLedgerInfo[k].workOrderOtherDetails.lr_number
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].pickup_details.from_city_name
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].dropoff_details.to_city_name
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].truck_id?.truck_number
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].workOrderOtherDetails.ddc_no
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].workOrderOtherDetails.loading_point
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].workOrderOtherDetails.price_per_ton
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].workOrderOtherDetails.unloading_point
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].workOrderOtherDetails.loading_point *
                    ele.paymentLedgerInfo[k].workOrderOtherDetails
                      .price_per_ton ||
                    ele.paymentLedgerInfo[k].workOrderOtherDetails
                      .unloading_point *
                      ele.paymentLedgerInfo[k].workOrderOtherDetails
                        .price_per_ton
                );
                ledgerData.push(
                  ele.paymentLedgerInfo[k].workOrderOtherDetails
                    .sales_order_number
                );
                this.data.push(ele.paymentLedgerInfo[k]);
                this.ledgerList = new MatTableDataSource(this.data);
              }
            }
          });
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  reset() {
    this.ledgerForm.reset();
    this.listLedger(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.selectedTripData,
      this.lrNo,
      this.vchlNo,
      this.salesOrder,
      this.workOrder,
      this.tripStatus,
      this.download,
      this.perPage,
      this.page
    );
  }
  help() {
    this.router.navigateByUrl("/?target=support");
  }
}
